import { isArray, isEmpty, reduce } from 'lodash'

const getNodes = filterFunction => (result, node) => {
  if (filterFunction(node)) {
    result.push(node)
    return result
  }

  if (isArray(node.children)) {
    const children = reduce(node.children, getNodes(filterFunction), [])

    if (!isEmpty(children)) {
      result.push({ ...node, children })
    }
  }

  return result
}

const filterTree = (array, filterFunction) =>
  reduce(array, getNodes(filterFunction), [])

export default filterTree
